import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes, faExclamationCircle, faWarning } from "@fortawesome/free-solid-svg-icons";
import { ValidationStatusProps, SectionHeaderProps, DataRowProps, WarningModalProps } from "../types/confirmationTypes";
import styles from "../Confirmation.module.css";
import { LButton } from "@loffa/gpp-modules";

export const ValidationStatus = ({ isValid, label }: ValidationStatusProps) => (
  <div className={styles.validationItem}>
    <FontAwesomeIcon icon={isValid ? faCheck : faTimes} className={isValid ? styles.validIcon : styles.invalidIcon} />
    <span className={isValid ? styles.validText : styles.invalidText}>{label}</span>
  </div>
);

export const SectionHeader = ({ title }: SectionHeaderProps) => (
  <div className={styles.confirmationSectionHeader}>
    <h3>{title}</h3>
  </div>
);

export const DataRow = ({ label, value }: DataRowProps) => (
  <div className={styles.confirmationDataRow}>
    <span className={styles.confirmationDataLabel}>{label}:</span>
    <span className={styles.confirmationDataValue}>{value || "—"}</span>
  </div>
);

export const WarningModal = ({ incompleteSections, onCancel, onSaveAnyway, isVisible }: WarningModalProps) => {
  if (!isVisible) return null;
  
  return (
    <div className={styles.overrideWarningContainer}>
      <div className={styles.overrideWarningContent}>
        <FontAwesomeIcon icon={faExclamationCircle} className={styles.overrideWarningIcon} />
        <div className={styles.overrideWarningMessage}>
          <h4>Incomplete Form</h4>
          <p>The following sections have incomplete required fields:</p>
          <ul className={styles.incompleteSectionsList}>
            {incompleteSections.map((section, index) => (
              <li key={index}>{section}</li>
            ))}
          </ul>
          <p>Are you sure you want to save this configuration anyway?</p>
        </div>
      </div>
      <div className={styles.overrideWarningActions}>
        <LButton onClick={onCancel} themeColor="primary">Cancel</LButton>
        <LButton onClick={onSaveAnyway} className="red">
          <FontAwesomeIcon icon={faWarning} className={styles.buttonIcon} />
          Save Anyway
        </LButton>
      </div>
    </div>
  );
};